import InquiryFlowAppInline from '../inquiry_flow/components/inline/InquiryFlowAppInline.vue';
import InquiryFlowAppChat from '../inquiry_flow/components/chat/InquiryFlowAppChat.vue';
import { mountVueWithProps } from '../common/utils/vue';

document.addEventListener('DOMContentLoaded', () => {
  // /open/lp_m 用のパターン別コンポーネント
  const containers = document.querySelectorAll<HTMLElement>(
    '.inquiry-flow-container',
  );
  containers.forEach((el) => {
    const componentType = el.dataset.componentType;

    let component;
    switch (componentType) {
      case 'inline':
        component = InquiryFlowAppInline;
        break;
      case 'chat':
        component = InquiryFlowAppChat;
        break;
      default:
        console.error(`Unknown component type: ${componentType}`);
        return;
    }

    mountVueWithProps({ element: el, component });
  });
});
